<template>
  <div class="mt-3">
    <div class="text-h6 mb-2">{{ question }}</div>
    <div>
      <v-textarea variant="outlined" :autofocus="autofocus" v-model="response" @keyup="changed" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LongText",
  props: {
    question: {
      type: String,
      required: true
    },
    modelValue: {},
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      response: this.modelValue
    }
  },
  methods: {
    changed() {
      this.$emit('update:modelValue', this.response)
    }
  }
}
</script>

<style scoped>

</style>